import {ChartThemeEnum} from '../chart/chart-theme.enum';

export enum UiThemeEnum {
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  BRAND = 'BRAND',
  NEUTRAL = 'NEUTRAL',
  IN_PROGRESS = 'IN_PROGRESS',
  NEUTRAL_CONTRAST = 'NEUTRAL_CONTRAST',
  LIBRARY = 'LIBRARY',
}

export class UiThemeEnumUtil {
  public static borderClass(
    uiTheme: UiThemeEnum,
  ): string {
    let className: string | undefined;
    switch (uiTheme) {
      case UiThemeEnum.SUCCESS:
        className = 'border-j-border-completed';
        break;
      case UiThemeEnum.WARNING:
        className = 'border-j-border-warning';
        break;
      case UiThemeEnum.ERROR:
        className = 'border-j-border-error';
        break;
      case UiThemeEnum.BRAND:
        className = 'border-j-border-brand';
        break;
      case UiThemeEnum.NEUTRAL:
        className = 'border-j-border-neutral';
        break;
      case UiThemeEnum.NEUTRAL_CONTRAST:
        className = 'border-j-button-secondary-border';
        break;
      case UiThemeEnum.IN_PROGRESS:
        className = 'border-j-border-in-progress';
        break;
      case UiThemeEnum.LIBRARY:
        className = '';
        break;
    }
    return className;
  }

  public static bgClass(
    uiTheme: UiThemeEnum,
  ): string {
    let className: string | undefined;
    switch (uiTheme) {
      case UiThemeEnum.SUCCESS:
        className = 'bg-j-bg-completed';
        break;
      case UiThemeEnum.WARNING:
        className = 'bg-j-bg-warning';
        break;
      case UiThemeEnum.ERROR:
        className = 'bg-j-bg-error';
        break;
      case UiThemeEnum.BRAND:
        className = 'bg-j-bg-brand';
        break;
      case UiThemeEnum.NEUTRAL:
        className = 'bg-j-bg-neutral';
        break;
      case UiThemeEnum.NEUTRAL_CONTRAST:
        className = 'bg-j-bg-primary-dark';
        break;
      case UiThemeEnum.IN_PROGRESS:
        className = 'bg-j-bg-in-progress';
        break;
      case UiThemeEnum.LIBRARY:
        className = '';
        break;
    }
    return className;
  }

  public static bgFgClass(
    uiTheme: UiThemeEnum,
  ): string {
    let className: string | undefined;
    switch (uiTheme) {
      case UiThemeEnum.SUCCESS:
        className = 'bg-j-text-completed';
        break;
      case UiThemeEnum.WARNING:
        className = 'bg-j-text-warning';
        break;
      case UiThemeEnum.ERROR:
        className = 'bg-j-text-error';
        break;
      case UiThemeEnum.BRAND:
        className = 'bg-j-text-brand';
        break;
      case UiThemeEnum.NEUTRAL:
        className = 'bg-j-text-neutral';
        break;
      case UiThemeEnum.NEUTRAL_CONTRAST:
        className = 'bg-j-button-secondary-bg';
        break;
      case UiThemeEnum.IN_PROGRESS:
        className = 'bg-j-text-in-progress';
        break;
      case UiThemeEnum.LIBRARY:
        className = '';
        break;
    }
    return className;
  }

  public static textClass(
    uiTheme: UiThemeEnum | undefined,
  ): string {
    let className: string = '';
    switch (uiTheme) {
      case UiThemeEnum.SUCCESS:
        className = 'text-j-text-completed';
        break;
      case UiThemeEnum.WARNING:
        className = 'text-j-text-warning';
        break;
      case UiThemeEnum.ERROR:
        className = 'text-j-text-error';
        break;
      case UiThemeEnum.BRAND:
        className = 'text-j-text-brand';
        break;
      case UiThemeEnum.NEUTRAL:
        className = 'text-j-text-neutral';
        break;
      case UiThemeEnum.NEUTRAL_CONTRAST:
        className = 'text-j-button-secondary-fg';
        break;
      case UiThemeEnum.IN_PROGRESS:
        className = 'text-j-text-in-progress';
        break;
      case UiThemeEnum.LIBRARY:
        className = '';
        break;
    }
    return className;
  }

  public static iconClass(
    uiTheme: UiThemeEnum,
  ): string {
    let className: string | undefined;
    switch (uiTheme) {
      case UiThemeEnum.SUCCESS:
        className = 'text-j-completed-icon';
        break;
      case UiThemeEnum.WARNING:
        className = 'text-j-warning-icon';
        break;
      case UiThemeEnum.ERROR:
        className = 'text-j-error-icon';
        break;
      case UiThemeEnum.BRAND:
      case UiThemeEnum.NEUTRAL_CONTRAST:
        className = 'text-j-brand-icon';
        break;
      case UiThemeEnum.NEUTRAL:
        className = 'text-j-neutral-icon';
        break;
      case UiThemeEnum.IN_PROGRESS:
        className = 'text-j-in-progress-icon';
        break;
      case UiThemeEnum.LIBRARY:
        className = '';
        break;
    }
    return className;
  }


  public static chartGradientCssVar(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    uiTheme: UiThemeEnum,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    theme: ChartThemeEnum
  ): string {
    const cssVar: string = '--color-j-bg-primary';
    return cssVar;
  }

  public static subTitleFgClass(
    uiTheme: UiThemeEnum,
  ): string {
    let fgClass: string = 'text-j-text-tertiary';
    switch (uiTheme) {
      case UiThemeEnum.LIBRARY:
        fgClass = 'text-j-text-tertiary';
        break;
    }
    return fgClass;
  }

  public static headerIconClass(
    uiTheme: UiThemeEnum,
  ): string {
    let iconClass: string = 'text-j-text-tertiary';
    switch (uiTheme) {
      case UiThemeEnum.LIBRARY:
        iconClass = 'text-j-text-neutral';
        break;
    }
    return iconClass;
  }
  public static headerIconBgClass(
    uiTheme: UiThemeEnum,
  ): string {
    let iconClass: string = '';
    switch (uiTheme) {
      case UiThemeEnum.LIBRARY:
        iconClass = 'bg-white';
        break;
    }
    return iconClass;
  }

  public static extraGradientClasses(
    uiTheme: UiThemeEnum,
  ): string[] {
    const classes: string[] = [];
    switch (uiTheme) {
      case UiThemeEnum.NEUTRAL_CONTRAST:
        classes.push('bg-linear-to-r');
        break;
      case UiThemeEnum.IN_PROGRESS:
      case UiThemeEnum.SUCCESS:
        classes.push(
          ...[
            'bg-linear-45',
            'from-10%',
            'to-90%',
          ]
        );
        break;
      default:
        classes.push(
          ...[
            'bg-linear-27',
            'from-10%',
            'to-90%',
          ]
        );
        break;
      case UiThemeEnum.LIBRARY:
        classes.push(
          ...[
            'bg-linear-45',
            'from-0%',
            'to-100%',
          ]
        );
        break;
    }
    return classes;
  }
  public static funnelBgClasses(): string[] {
    const classes: string[] = [
      'bg-linear-45',
      'from-0%',
      'to-100%',
      'from-j-bg-card-gradient-1',
      'to-j-bg-card-gradient-2',
    ];
    return classes;
  }
}
